import type { Campaign, Dispatch } from "../types";

const now = new Date().toISOString();
const yesterday = new Date(Date.now() - 86400000).toISOString();

/** Lista mutável de campanhas para mock (create/update alteram este array) */
export const mockCampaigns: Campaign[] = [
  {
    id: "mock-campaign-1",
    title: "Boas-vindas novos usuários",
    channel: "email",
    status: "sent",
    scheduledAt: "2024-03-01T10:00:00Z",
    recipientCount: 150,
    subject: "Bem-vindo ao LikeAppro",
    body: "Olá! Estamos felizes em tê-lo conosco.",
    recipientOption: "all",
    createdAt: "2024-02-28T14:00:00Z",
    updatedAt: "2024-03-01T10:05:00Z",
  },
  {
    id: "mock-campaign-2",
    title: "Lembrete de evento",
    channel: "notification",
    status: "scheduled",
    scheduledAt: "2024-04-15T09:00:00Z",
    recipientCount: 320,
    subject: null,
    body: "Não esqueça: evento no próximo sábado.",
    recipientOption: "all",
    createdAt: "2024-03-10T11:00:00Z",
    updatedAt: "2024-03-10T11:00:00Z",
  },
  {
    id: "mock-campaign-3",
    title: "Rascunho campanha promoção",
    channel: "email",
    status: "draft",
    scheduledAt: null,
    recipientCount: 0,
    subject: "Promoção especial",
    body: "Em breve novidades.",
    recipientOption: "all",
    createdAt: yesterday,
    updatedAt: now,
  },
  {
    id: "mock-campaign-4",
    title: "Newsletter março 2024",
    channel: "email",
    status: "sent",
    scheduledAt: "2024-03-15T08:00:00Z",
    recipientCount: 2100,
    subject: "Newsletter LikeAppro — Março",
    body: "Confira as novidades do mês...",
    recipientOption: "all",
    createdAt: "2024-03-14T16:00:00Z",
    updatedAt: "2024-03-15T08:30:00Z",
  },
  {
    id: "mock-campaign-5",
    title: "Alerta de manutenção",
    channel: "notification",
    status: "sent",
    scheduledAt: "2024-03-20T22:00:00Z",
    recipientCount: 890,
    subject: null,
    body: "Manutenção programada para domingo às 02h.",
    recipientOption: "all",
    createdAt: "2024-03-20T18:00:00Z",
    updatedAt: "2024-03-20T22:10:00Z",
  },
  {
    id: "mock-campaign-6",
    title: "Campanha cancelada — teste",
    channel: "email",
    status: "cancelled",
    scheduledAt: "2024-04-01T12:00:00Z",
    recipientCount: 0,
    subject: "Teste cancelado",
    body: "Campanha de teste.",
    recipientOption: "segment",
    createdAt: "2024-03-25T10:00:00Z",
    updatedAt: "2024-03-26T09:00:00Z",
  },
  {
    id: "mock-campaign-7",
    title: "Black Friday — rascunho",
    channel: "email",
    status: "draft",
    scheduledAt: null,
    recipientCount: 0,
    subject: "Black Friday LikeAppro",
    body: "Ofertas exclusivas em breve.",
    recipientOption: "all",
    createdAt: "2024-03-01T09:00:00Z",
    updatedAt: "2024-03-05T14:00:00Z",
  },
  {
    id: "mock-campaign-8",
    title: "Webinar abril — agendada",
    channel: "notification",
    status: "scheduled",
    scheduledAt: "2024-04-10T14:00:00Z",
    recipientCount: 450,
    subject: null,
    body: "Participe do webinar no dia 10/04.",
    recipientOption: "segment",
    createdAt: "2024-03-28T11:00:00Z",
    updatedAt: "2024-03-28T11:00:00Z",
  },
];

/** Disparos mock por campanha */
export const mockDispatchesByCampaign: Record<string, Dispatch[]> = {
  "mock-campaign-1": [
    {
      id: "mock-dispatch-1-1",
      campaignId: "mock-campaign-1",
      status: "sent",
      sentAt: "2024-03-01T10:01:00Z",
      recipientId: "user-1",
      recipientLabel: "usuário@exemplo.com",
      createdAt: "2024-03-01T10:00:00Z",
    },
    {
      id: "mock-dispatch-1-2",
      campaignId: "mock-campaign-1",
      status: "sent",
      sentAt: "2024-03-01T10:02:00Z",
      recipientId: "user-2",
      recipientLabel: "outro@exemplo.com",
      createdAt: "2024-03-01T10:00:00Z",
    },
    {
      id: "mock-dispatch-1-3",
      campaignId: "mock-campaign-1",
      status: "failed",
      sentAt: null,
      recipientId: "user-3",
      recipientLabel: "invalido@dominio",
      createdAt: "2024-03-01T10:00:00Z",
    },
  ],
  "mock-campaign-2": [
    {
      id: "mock-dispatch-2-1",
      campaignId: "mock-campaign-2",
      status: "pending",
      sentAt: null,
      recipientId: "notif-1",
      recipientLabel: "Usuário A (push)",
      createdAt: "2024-03-10T11:00:00Z",
    },
    {
      id: "mock-dispatch-2-2",
      campaignId: "mock-campaign-2",
      status: "pending",
      sentAt: null,
      recipientId: "notif-2",
      recipientLabel: "Usuário B (push)",
      createdAt: "2024-03-10T11:00:00Z",
    },
  ],
  "mock-campaign-3": [],
  "mock-campaign-4": [
    {
      id: "mock-dispatch-4-1",
      campaignId: "mock-campaign-4",
      status: "sent",
      sentAt: "2024-03-15T08:01:00Z",
      recipientId: "n1",
      recipientLabel: "assinante1@email.com",
      createdAt: "2024-03-15T08:00:00Z",
    },
    {
      id: "mock-dispatch-4-2",
      campaignId: "mock-campaign-4",
      status: "sent",
      sentAt: "2024-03-15T08:01:05Z",
      recipientId: "n2",
      recipientLabel: "assinante2@email.com",
      createdAt: "2024-03-15T08:00:00Z",
    },
    {
      id: "mock-dispatch-4-3",
      campaignId: "mock-campaign-4",
      status: "sent",
      sentAt: "2024-03-15T08:01:10Z",
      recipientId: "n3",
      recipientLabel: "assinante3@email.com",
      createdAt: "2024-03-15T08:00:00Z",
    },
    {
      id: "mock-dispatch-4-4",
      campaignId: "mock-campaign-4",
      status: "failed",
      sentAt: null,
      recipientId: "n4",
      recipientLabel: "bounce@dominio-invalido.com",
      createdAt: "2024-03-15T08:00:00Z",
    },
  ],
  "mock-campaign-5": [
    {
      id: "mock-dispatch-5-1",
      campaignId: "mock-campaign-5",
      status: "sent",
      sentAt: "2024-03-20T22:00:30Z",
      recipientId: "u1",
      recipientLabel: "Device user-abc",
      createdAt: "2024-03-20T22:00:00Z",
    },
    {
      id: "mock-dispatch-5-2",
      campaignId: "mock-campaign-5",
      status: "sent",
      sentAt: "2024-03-20T22:00:35Z",
      recipientId: "u2",
      recipientLabel: "Device user-def",
      createdAt: "2024-03-20T22:00:00Z",
    },
  ],
  "mock-campaign-6": [],
  "mock-campaign-7": [],
  "mock-campaign-8": [
    {
      id: "mock-dispatch-8-1",
      campaignId: "mock-campaign-8",
      status: "pending",
      sentAt: null,
      recipientId: "seg-1",
      recipientLabel: "Segmento Webinar (450 destinatários)",
      createdAt: "2024-03-28T11:00:00Z",
    },
  ],
};

export function getMockCampaigns(): Campaign[] {
  return [...mockCampaigns];
}

export function getMockDispatches(campaignId: string): Dispatch[] {
  return [...(mockDispatchesByCampaign[campaignId] ?? [])];
}
